export default __webpack_public_path__ + "static/media/before-footer-img5.39142afd.png";